import { defineStore } from 'pinia';
import { ref } from 'vue';
import { SetupStoreId } from '@/enum';
import { fetchPostDataCenterList } from '@/service/api';
import { localStg } from '@/utils/storage';

export const useDataCenterStore = defineStore(SetupStoreId.DataCenter, () => {
  const currentData = ref(localStg.get('currentDataCenter'));
  const dataCenterList = ref(localStg.get('dataCenterList'));
  const isCurrentData = ref(localStg.get('isNoCrossService'));
  const getDataCenterList = async (dataCenterId?: number) => {
    // 获取数据中心列表
    const { data: dataCenterData } = await fetchPostDataCenterList();
    if (dataCenterData) {
      // 缓存数据中心列表
      localStg.set('dataCenterList', dataCenterData);
      dataCenterList.value = dataCenterData;

      const current = dataCenterData.find(item => item.current);

      // 缓存当前数据中心
      if (current) {
        localStg.set('currentDataCenter', current);
        localStg.set('userSelectServe', current);
        currentData.value = current;
      }

      if (dataCenterId) {
        localStg.set('isNoCrossService', currentData.value?.id === dataCenterId);
        isCurrentData.value = currentData.value?.id === dataCenterId;
      }

      return dataCenterData;
    }

    return [];
  };

  /**
   * 判断当前是否存在跨数据访问的情况
   *
   * @param dataCenterId
   * @returns true不存在 false存在
   */
  const IsCurrentDataCenter = () => {
    return isCurrentData.value;
  };

  return {
    currentData,
    dataCenterList,
    isCurrentData,
    getDataCenterList,
    IsCurrentDataCenter
  };
});
